import { render, staticRenderFns } from "./KeyValueAdd.vue?vue&type=template&id=5b72f7ad&scoped=true"
import script from "./KeyValueAdd.vue?vue&type=script&lang=js"
export * from "./KeyValueAdd.vue?vue&type=script&lang=js"
import style0 from "./KeyValueAdd.vue?vue&type=style&index=0&id=5b72f7ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72f7ad",
  null
  
)

export default component.exports